<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { CustomerRow } from "../../_shared/_logic/customers-table-contract"
  import { contactKindColor, contactKindIcon } from "../../_shared/_logic/contact-presentation"

  let { row }: { row: CustomerRow } = $props()
  const contactTags = $derived(row.contactTags ?? [])
</script>

{#if contactTags.length}
  <span class="contact-cell">
    {#each contactTags as tag (`${row.id}-${tag.id}`)}
      <StatusTag
        variant="neutral"
        size="sm"
        label={tag.label}
        icon={contactKindIcon(tag.kind)}
        color={contactKindColor(tag.kind)}
        tooltipContent={tag.tooltip}
        tooltipHtml={tag.tooltipHtml ?? false}
        tooltipClassName={tag.tooltipHtml ? RICH_TOOLTIP_CLASS : ""}
      />
    {/each}
  </span>
{:else if row.contactValue}
  <span class="contact-cell">
    <StatusTag
      variant="neutral"
      size="sm"
      label={row.contactValue}
      icon={contactKindIcon(row.contactKind)}
      color={contactKindColor(row.contactKind)}
      tooltipContent={row.contactTooltip}
    />
  </span>
{:else}
  <span>–</span>
{/if}

<style lang="less">
  .contact-cell {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    line-height: 1.25;
    white-space: normal;
  }
</style>
